import type { ListBatchJobItemsParams } from "../../../../../lib/corpusApi";

export type PubmedIngestTabKey =
  "ingested" | "needs_review" | "rejected" | "previously_rejected" | "existing" | "failed";

export interface PubmedIngestTabConfig {
  label: string;
  /** Query params sent to GET /batch-jobs/:id/items for this tab. */
  apiFilters: Pick<ListBatchJobItemsParams, "status" | "outcome">;
  /** Whether the rejection-code filter is shown — only for tabs whose items carry a rejection. */
  rejectionFilterable: boolean;
}

/** One tab per thing that can become of an article. Order here is display order. */
export const PUBMED_INGEST_TABS: Record<PubmedIngestTabKey, PubmedIngestTabConfig> = {
  ingested: {
    label: "Ingested",
    apiFilters: { outcome: "ingested" },
    rejectionFilterable: false,
  },
  needs_review: {
    label: "Needs review",
    apiFilters: { outcome: "needs_review" },
    rejectionFilterable: false,
  },
  rejected: {
    label: "Rejected by the gate",
    apiFilters: { outcome: "rejected" },
    rejectionFilterable: true,
  },
  previously_rejected: {
    label: "Previously rejected",
    apiFilters: { outcome: "previously_rejected" },
    rejectionFilterable: true,
  },
  existing: {
    label: "Already in corpus",
    apiFilters: { outcome: "existing" },
    rejectionFilterable: false,
  },
  failed: {
    label: "Failed",
    apiFilters: { status: "failed" },
    rejectionFilterable: false,
  },
};

export const PUBMED_INGEST_TAB_ORDER: PubmedIngestTabKey[] = [
  "ingested",
  "needs_review",
  "rejected",
  "previously_rejected",
  "existing",
  "failed",
];
